export default "__VITE_ASSET__CFvKqz$3__"